import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import monthList from '../PublicHoliday/monthList.json'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import moment from 'moment'
import numeral from 'numeral';
import 'numeral/locales/de'
import {
  Grid, Button, MenuItem, TextField,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from '@material-ui/core';
import { GetConsultantsPlans, GetProjectConsultants } from './beraterplanAction';
import OverLoader from '../../components/common/loader';
import { LogoutAction } from '../../actions';

numeral.locale('de');

const dateFormat = 'YYYY';

class Beraterplan extends Component {

  state = {
    yearField: new Date().getFullYear(),
    sumDaysold: [],
    sumDaysassigned: [],
    consultant: [],
    consultantVal: JSON.parse(localStorage.getItem("user")).id,
    sumIst: [],
    monthsKey: ["year_summary", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }


  componentDidMount = () => {
    const { GetProjectConsultants } = this.props
    GetProjectConsultants()
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { propsProjectData, consultantVal, projectPlans, monthsKey, yearField } = this.state
    const { consultant_list, updateProjectPlan, CreateProjectPlansForYear, GetConsultantsPlans } = this.props
    if (nextProps.consultant_list !== consultant_list) {
      this.setState({ consultant: nextProps.consultant_list })
      nextProps.consultant_list.forEach(list => {
        if (list.id === consultantVal)
          GetConsultantsPlans(consultantVal, yearField)
      })
    }
    if (nextProps.updateProjectPlan !== updateProjectPlan && nextProps.updateProjectPlan === true) {
      CreateProjectPlansForYear(propsProjectData.id, projectPlans, monthsKey, yearField)
    }
  }

  monthCells = () => {
    return (
      monthList.map((item, index) => <TableCell key={index} align="center">{item.name}</TableCell>)
    )
  }



  yearFieldHandleChange = (e) => {
    if (e !== null) {
      let date = moment(e._d).format("YYYY");
      this.setState({ yearField: date }, () => this.getConsultantPlans())
    } else {
      this.setState({ yearField: '' })
    }
  }


  getConsultantPlans = () => {
    const { GetConsultantsPlans } = this.props
    const { yearField, consultantVal } = this.state
    const token = localStorage.getItem('access-token')
    if (consultantVal !== '' && token !== null)
      GetConsultantsPlans(consultantVal, yearField)
  }

  render() {
    const { yearField, monthsKey, consultant, consultantVal } = this.state
    const { bareter_plan, summary_sum, isloading, consultant_pdf } = this.props
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="plainingTab plainingTab-action">
        {isloading && <OverLoader />}
        <Grid container spacing={2}>
          <Grid item xs={3} className="inner-p-label">
            <div className="innermeLable">Berater</div>
            <TextField
              value={consultantVal}
              style={{ padding: "10px" }}
              select
              variant="outlined"
              className="select-box"
              size="small"
              onChange={(e) => {
                this.setState({ consultantVal: e.target.value }, () => this.getConsultantPlans())
              }}
            >
              {consultant && consultant.map((item, index) =>
                <MenuItem key={index} value={item.id}>{item.full_name}</MenuItem>
              )}

            </TextField>
          </Grid>
          <Grid item xs={2} className="inner-p-label">
            <div className="innermeLable">Jahr</div>
            <DatePicker
              value={yearField === "" ? '' : moment(yearField, dateFormat)}
              format={dateFormat}
              allowClear={false}
              bordered={false}
              onChange={(e) => {
                this.yearFieldHandleChange(e)
              }}
              picker="year" />
          </Grid>
          {!isEmpty(consultant_pdf) && !isEmpty(bareter_plan) &&
            <Grid item xs={4} className="inner-p-label">
              {/* <a href={consultant_pdf} target="_blank"> */}
              <Button variant="outlined" color="primary"
                onClick={() => {
                  const theLink = document.createElement('a');
                  theLink.href = consultant_pdf;
                  theLink.download = "Beraterplan_" + yearField + '.pdf';
                  document.body.appendChild(theLink);
                  theLink.click();
                  document.body.removeChild(theLink);
                }
                }
              >Drucken</Button>
              {/* </a> */}
            </Grid>
          }
        </Grid>
        {!isEmpty(bareter_plan) &&
          <div className="plainingTable">
            <Grid container spacing={0}>
              <Grid item xs={2}>
                <TableContainer>
                  <Table>
                    <TableHead className="pl-heading">
                      <TableRow>
                        <TableCell colSpan='3' align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow className="pl-heading">
                        <TableCell align="left">
                          <div className="innerMonth">
                            <div className="text-left">Pro. Nr.</div>
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="innerMonth">
                            <div className="text-left">Pro. Name</div>
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="innerMonth">
                            <div className="text-left">Kunde</div>
                          </div>
                        </TableCell>
                      </TableRow>

                      {bareter_plan &&
                        bareter_plan.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="left">
                              <div className="innerMonth">
                                <div className="text-left">{item.projectno}</div>
                              </div>
                            </TableCell>
                            <TableCell align="left">
                              <div className="innerMonth">
                                <div className="text-left projectNameStyle">{item.projectname}</div>
                              </div>
                            </TableCell>
                            <TableCell align="left">
                              <div className="innerMonth">
                                <div className="text-left projectNameStyle">{item.customer_name}</div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      }
                      <TableRow>
                        <TableCell colSpan='3' align="left">
                          <div className="innerMonth">
                            <div className="text-left">Summe extern:</div>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan='3' align="left">
                          <div className="innerMonth">
                            <div className="text-left">Summe intern:</div>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan='3' align="left">
                          <div className="innerMonth">
                            <div className="text-left">Summe gesamt:</div>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={10}>
                <div className="overflow-x-auto">
                  <TableContainer>
                    <Table>
                      <TableHead className="pl-heading">
                        <TableRow>
                          <TableCell align="center">{yearField}</TableCell>
                          {this.monthCells()}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className="pl-heading">
                          <TableCell align="right">
                            <div className="innerMonth">
                              <div className="bluebox">Verk</div>
                              <div className="light-bluebox">Verg</div>
                              <div>Ist</div>
                            </div>
                          </TableCell>
                          {monthList &&
                            monthList.map((item, index) =>
                              <TableCell key={index} align="right">
                                <div className="innerMonth">
                                  <div className="bluebox">Verk</div>
                                  <div className="light-bluebox">Verg</div>
                                  <div>Ist</div>
                                </div>
                              </TableCell>
                            )
                          }
                        </TableRow>
                        {bareter_plan &&
                          bareter_plan.map((item, index) =>
                            <TableRow key={index}>
                              {monthsKey.map((month, index) => {
                                return (
                                  item.project_plans[month] ?
                                    <TableCell key={index} align="right">
                                      <div className="innerMonth">
                                        <div className="bluebox">
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            inputProps={{
                                              maxLength: 10
                                            }}
                                            value={item.project_plans[month].dayssold !== "" && item.project_plans[month].dayssold !== "0.0"
                                              ? Number(Number(item.project_plans[month].dayssold).toFixed(1)) : ''}
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale="1"
                                            allowNegative={false}
                                            disabled
                                          />
                                        </div>
                                        <div className="light-bluebox">
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            inputProps={{
                                              maxLength: 10
                                            }}
                                            value={(item.project_plans[month].daysassigned !== "" && item.project_plans[month].daysassigned !== "0.0") ?
                                              Number(Number(item.project_plans[month].daysassigned).toFixed(1)) : ''}
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale="1"
                                            allowNegative={false}
                                            disabled
                                          />
                                        </div>
                                        <div>
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            value={(item.project_plans[month].ist !== "" && item.project_plans[month].ist !== "0.0") ? Number(Number(item.project_plans[month].ist).toFixed(1)) : ''}
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale="1"
                                            allowNegative={false}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </TableCell>
                                    :
                                    <TableCell key={index} align="right">
                                      <div className="innerMonth">
                                        <div className="bluebox">
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            inputProps={{
                                              maxLength: 10
                                            }}
                                            value={''}
                                            disabled
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale="1"
                                            allowNegative={false}

                                          /></div>
                                        <div className="light-bluebox">
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            inputProps={{
                                              maxLength: 10
                                            }}
                                            value={''}
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale="1"
                                            allowNegative={false}
                                            disabled
                                          />
                                        </div>
                                        <div>
                                          <NumberFormat
                                            customInput={TextField}
                                            className={`innerInput showData rightToLeft ${month === "year_summary" && "bolder"}`}
                                            value={''}
                                            fixedDecimalScale={true}
                                            thousandSeparator='.'
                                            decimalSeparator=","
                                            decimalScale="1"
                                            allowNegative={false}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </TableCell>
                                )
                              })}

                            </TableRow>
                          )
                        }
                        <TableRow>
                          {monthsKey && summary_sum &&
                            monthsKey.map((item, index) => {
                              return (
                                summary_sum.sum_extern[item] ?
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          className="innerInput showData rightToLeft bolder"
                                          value={(summary_sum.sum_extern[item].dayssold !== 0 && summary_sum.sum_extern[item].dayssold !== "") ? Number(Number(summary_sum.sum_extern[item].dayssold).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                          disabled
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          className="innerInput showData bolder rightToLeft"
                                          value={(summary_sum.sum_extern[item].daysassigned !== 0 && summary_sum.sum_extern[item].daysassigned !== "") ? Number(Number(summary_sum.sum_extern[item].daysassigned).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                          disabled
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          customInput={TextField}
                                          className="innerInput showData bolder rightToLeft"
                                          fixedDecimalScale={true}
                                          value={(summary_sum.sum_extern[item].ist !== 0 && summary_sum.sum_extern[item].ist !== "") ? Number(Number(summary_sum.sum_extern[item].ist).toFixed(1)) : ''}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                  :
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData rightToLeft bolder"
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                              )
                            }
                            )
                          }
                        </TableRow>
                        <TableRow>
                          {monthsKey && summary_sum &&
                            monthsKey.map((item, index) => {
                              return (
                                summary_sum.sum_intern[item] ?
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          className="innerInput showData bolder rightToLeft"
                                          disabled
                                          value={(summary_sum.sum_intern[item].dayssold !== 0 && summary_sum.sum_intern[item].dayssold !== "") ? Number(Number(summary_sum.sum_intern[item].dayssold).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                          value={(summary_sum.sum_intern[item].daysassigned !== 0 && summary_sum.sum_intern[item].daysassigned !== "") ? Number(Number(summary_sum.sum_intern[item].daysassigned).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          customInput={TextField}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                          fixedDecimalScale={true}
                                          value={(summary_sum.sum_intern[item].ist !== 0 && summary_sum.sum_intern[item].ist !== "") ? Number(Number(summary_sum.sum_intern[item].ist).toFixed(1)) : ''}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                  :
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData rightToLeft bolder"
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                              )
                            }
                            )
                          }
                        </TableRow>
                        <TableRow>
                          {monthsKey && summary_sum &&
                            monthsKey.map((item, index) => {
                              return (
                                summary_sum.sum_all[item] ?
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                          value={(summary_sum.sum_all[item].dayssold !== 0 && summary_sum.sum_all[item].dayssold !== "") ? Number(Number(summary_sum.sum_all[item].dayssold).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                          value={(summary_sum.sum_all[item].daysassigned !== 0 && summary_sum.sum_all[item].daysassigned !== "") ? Number(Number(summary_sum.sum_all[item].daysassigned).toFixed(1)) : ''}
                                          fixedDecimalScale={true}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          customInput={TextField}
                                          disabled
                                          className="innerInput showData bolder rightToLeft"
                                          fixedDecimalScale={true}
                                          value={(summary_sum.sum_all[item].ist !== 0 && summary_sum.sum_all[item].ist !== "") ? Number(Number(summary_sum.sum_all[item].ist).toFixed(1)) : ''}
                                          thousandSeparator='.'
                                          decimalSeparator=","
                                          decimalScale="1"
                                          allowNegative={false}
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                  :
                                  <TableCell key={index} align="right">
                                    <div className="innerMonth">
                                      <div className="bluebox">
                                        <NumberFormat
                                          disabled
                                          customInput={TextField}
                                          value={''}
                                          className="innerInput showData rightToLeft bolder"
                                        />
                                      </div>
                                      <div className="light-bluebox">
                                        <NumberFormat
                                          customInput={TextField}
                                          value={''}
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                      <div>
                                        <NumberFormat
                                          disabled
                                          customInput={TextField}
                                          value={''}
                                          className="innerInput showData bolder rightToLeft"
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                              )
                            }
                            )
                          }
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
            </Grid>

          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ beraterPlan }) => {
  return {
    bareter_plan: beraterPlan.bareter_plan,
    consultant_pdf: beraterPlan.consultant_pdf,
    isloading: beraterPlan.loading,
    summary_sum: beraterPlan.summary_sum,
    consultant_list: beraterPlan.consultant_list,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetConsultantsPlans: (year, id) => dispatch(GetConsultantsPlans(year, id)),
    GetProjectConsultants: () => dispatch(GetProjectConsultants()),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Beraterplan)